import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 360px;
  height: 30px;
  margin-bottom: 20px;
  border-bottom: 1px solid #d6d6d6;
  padding-left: 40px;
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  top: 2px;
  left: 0;
`;

export const InputSearchCompany = styled.input`
  width: 100%;
  height: 30px;
  line-height: 30px;
  background: none;
  border-width: 0;
  font-size: 14px;
  font-weight: 500;
  outline: 0;
  appearance: none;
  background-color: transparent;
`;

export const SuggestionCompany = styled.div`
  position: absolute;
  bottom: -2px;
  left: 0;
  transform: translate3d(0, 100%, 0);
  width: 100%;
  min-height: 180px;
  max-height: 340px;
  padding: 16px 0 8px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  z-index: 1001;
  overflow-y: auto;
`;

export const SuggestionTitle = styled.div`
  padding: 0 28px 0;
  margin-bottom: 10px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray600};
`;

export const SuggestionCompanyItem = styled.a`
  display: block;
  padding: 12px 28px;
  font-size: 14px;

  strong {
    font-weight: normal;
    color: ${({ theme }) => theme.colors.magenta700};
  }

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const NoData = styled.div`
  padding-top: 16px;
  padding-left: 28px;
`;
